
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationDeleteHeadline: {
    id: "Delete.headline",
    defaultMessage: "Are you sure you want to delete your configuration?",
  },
  configurationDeleteButton: {
    id: "Delete.button",
    defaultMessage: "Accept",
  }, 
});

export default MESSAGES;